import {type RefObject, useCallback, useEffect, useState} from "react";

import {useUserDevice} from "@pg-mono/user-device";

const MAIN_CONTAINER_MAX_WIDTH = 1576;
const SIDEBAR_MAX_WIDTH = 488;
const ADDITIONAL_SPACING = 32;

const BREAKPOINT_4_COLS = 1240;
const BREAKPOINT_3_COLS = 920;
const BREAKPOINT_2_COLS = 680;

type GridStyle = {
    flex: string;
    maxWidth: string;
} | null;

const calculateGridStyle = (containerWidth: number): GridStyle => {
    if (containerWidth >= BREAKPOINT_4_COLS) {
        return null;
    }

    if (containerWidth >= BREAKPOINT_3_COLS) {
        return {
            flex: "1 0 calc(100% / 3)",
            maxWidth: "calc(100% / 3)"
        };
    }

    if (containerWidth >= BREAKPOINT_2_COLS) {
        return {
            flex: "1 0 calc(100% / 2)",
            maxWidth: "calc(100% / 2)"
        };
    }

    return {
        flex: "1 0 calc(100% / 1)",
        maxWidth: "calc(100% / 1)"
    };
};

/**
 * Dynamically adjusts the offer list container width to prevent overlap with FloatingSemanticSearchSidebar.
 * Returns calculated width and grid styles (2, 3, or 4 columns) based on available space.
 */
export const useFloatingSemanticSearchSidebarWidth = (sectionRef: RefObject<HTMLElement | null>) => {
    const {isMobile} = useUserDevice();
    const [containerWidth, setContainerWidth] = useState(MAIN_CONTAINER_MAX_WIDTH);
    const [gridStyle, setGridStyle] = useState<GridStyle>(null);
    const [isOpen, setIsOpen] = useState(false);

    const onOpenChange = useCallback((open: boolean) => {
        setIsOpen(open);
    }, []);

    useEffect(() => {
        const calculateWidth = () => {
            const viewportWidth = window.innerWidth;

            if (isMobile) {
                setContainerWidth(MAIN_CONTAINER_MAX_WIDTH);
                setGridStyle(null);
                return;
            }

            const parentContainerWidth = Math.min(viewportWidth, MAIN_CONTAINER_MAX_WIDTH);

            if (!isOpen) {
                const calculatedStyle = calculateGridStyle(parentContainerWidth);

                setContainerWidth(parentContainerWidth);
                setGridStyle(calculatedStyle);
                return;
            }

            const containerLeftEdge = (viewportWidth - parentContainerWidth) / 2;
            const containerRightEdge = containerLeftEdge + parentContainerWidth;
            const availableSpaceForSidebar = viewportWidth - containerRightEdge;

            if (availableSpaceForSidebar >= SIDEBAR_MAX_WIDTH + ADDITIONAL_SPACING) {
                const calculatedStyle = calculateGridStyle(parentContainerWidth);

                setContainerWidth(parentContainerWidth);
                setGridStyle(calculatedStyle);
                return;
            }

            const sidebarOverlap = SIDEBAR_MAX_WIDTH + ADDITIONAL_SPACING - availableSpaceForSidebar;
            const reducedWidth = parentContainerWidth - sidebarOverlap;
            const minWidth = 600;
            const finalWidth = Math.max(minWidth, reducedWidth);
            const calculatedStyle = calculateGridStyle(finalWidth);

            setContainerWidth(finalWidth);
            setGridStyle(calculatedStyle);
        };

        calculateWidth();

        window.addEventListener("resize", calculateWidth);

        return () => {
            window.removeEventListener("resize", calculateWidth);
        };
    }, [sectionRef, isOpen, isMobile]);

    return {width: containerWidth, gridStyle, onOpenChange};
};
import {type RefObject, useCallback, useEffect, useState} from "react";

import {useUserDevice} from "@pg-mono/user-device";

const MAIN_CONTAINER_MAX_WIDTH = 1576;
const SIDEBAR_MAX_WIDTH = 488;
const ADDITIONAL_SPACING = 32;

const BREAKPOINT_4_COLS = 1240;
const BREAKPOINT_3_COLS = 920;
const BREAKPOINT_2_COLS = 680;

type GridStyle = {
    flex: string;
    maxWidth: string;
} | null;

const calculateGridStyle = (containerWidth: number): GridStyle => {
    if (containerWidth >= BREAKPOINT_4_COLS) {
        return null;
    }

    if (containerWidth >= BREAKPOINT_3_COLS) {
        return {
            flex: "1 0 calc(100% / 3)",
            maxWidth: "calc(100% / 3)"
        };
    }

    if (containerWidth >= BREAKPOINT_2_COLS) {
        return {
            flex: "1 0 calc(100% / 2)",
            maxWidth: "calc(100% / 2)"
        };
    }

    return {
        flex: "1 0 calc(100% / 1)",
        maxWidth: "calc(100% / 1)"
    };
};

/**
 * Dynamically adjusts the offer list container width to prevent overlap with FloatingSemanticSearchSidebar.
 * Returns calculated width and grid styles (2, 3, or 4 columns) based on available space.
 */
export const useFloatingSemanticSearchSidebarWidth = (sectionRef: RefObject<HTMLElement | null>) => {
    const {isMobile} = useUserDevice();
    const [containerWidth, setContainerWidth] = useState(MAIN_CONTAINER_MAX_WIDTH);
    const [gridStyle, setGridStyle] = useState<GridStyle>(null);
    const [isOpen, setIsOpen] = useState(false);

    const onOpenChange = useCallback((open: boolean) => {
        setIsOpen(open);
    }, []);

    useEffect(() => {
        const calculateWidth = () => {
            const viewportWidth = window.innerWidth;

            if (isMobile) {
                setContainerWidth(MAIN_CONTAINER_MAX_WIDTH);
                setGridStyle(null);
                return;
            }

            const parentContainerWidth = Math.min(viewportWidth, MAIN_CONTAINER_MAX_WIDTH);

            if (!isOpen) {
                const calculatedStyle = calculateGridStyle(parentContainerWidth);

                setContainerWidth(parentContainerWidth);
                setGridStyle(calculatedStyle);
                return;
            }

            const containerLeftEdge = (viewportWidth - parentContainerWidth) / 2;
            const containerRightEdge = containerLeftEdge + parentContainerWidth;
            const availableSpaceForSidebar = viewportWidth - containerRightEdge;

            if (availableSpaceForSidebar >= SIDEBAR_MAX_WIDTH + ADDITIONAL_SPACING) {
                const calculatedStyle = calculateGridStyle(parentContainerWidth);

                setContainerWidth(parentContainerWidth);
                setGridStyle(calculatedStyle);
                return;
            }

            const sidebarOverlap = SIDEBAR_MAX_WIDTH + ADDITIONAL_SPACING - availableSpaceForSidebar;
            const reducedWidth = parentContainerWidth - sidebarOverlap;
            const minWidth = 600;
            const finalWidth = Math.max(minWidth, reducedWidth);
            const calculatedStyle = calculateGridStyle(finalWidth);

            setContainerWidth(finalWidth);
            setGridStyle(calculatedStyle);
        };

        calculateWidth();

        window.addEventListener("resize", calculateWidth);

        return () => {
            window.removeEventListener("resize", calculateWidth);
        };
    }, [sectionRef, isOpen, isMobile]);

    return {width: containerWidth, gridStyle, onOpenChange};
};
